import React from "react";
var __jsx = React.createElement;
import componentsMap from "./components";
function ComponentRenderer(props) {
  var Component = componentsMap === null || componentsMap === void 0 ? void 0 : componentsMap[props.entry.__typename];
  if (!Component) {
    return function () {};
  }
  return __jsx(Component, props);
}
export default ComponentRenderer;